export default __webpack_public_path__ + "static/media/logo-us-ralph-lauren.6069431d.svg";